import { render, staticRenderFns } from "./Bangkok.vue?vue&type=template&id=028ae33f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports